// extracted by mini-css-extract-plugin
module.exports = {"loading-indicator":"loading-indicator-2IbcSLu","white":"white-UDuJD64","icon":"icon-2gvj6uf","grey":"grey-1FKLfTq","icon-wrapper":"icon-wrapper-1RjL0OR","spin":"spin-PY0BNn3"};